







































































































































































































import {Component, Prop, Model} from 'vue-property-decorator';
import Video from '../api/video';
import {BusEvent} from '@/models/bus';
import CommonVue from '../models/commonVue';
import Modal from '@/components/Modal.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import MultiDropdownList from "@/components/MultiDropdownList.vue";
import {Tags} from "@/api/common";
import FieldInternational from "@/components/FieldInternational.vue";
import FieldInterfaceElements from "@/components/FieldInterfaceElements.vue";

@Component({
    components: {
        'field-interface-elements': FieldInterfaceElements,
        'modal': Modal,
        'edit-icon': EditIcon,
        'multi-dropdown-list': MultiDropdownList,
        'field-international': FieldInternational,
    },
})
export default class FieldVideos extends CommonVue {
    @Model('changeVideos') public videos!: Video[];
    @Prop({type: Boolean, default: false}) public disabled?: boolean;

    public video: Video = null;
    public showModal: boolean = false;

    public start_time: string = undefined;
    public end_time: string = undefined;
    public display_condition: string = undefined;
    public tags: string[] = undefined;

    public tagOptions: string[] = Tags.OPTIONS;
    public tagPresentation: string[] = Tags.PRESENTATION;


    // noinspection JSMethodCanBeStatic
    public timeToString(time: number): string {
        if (time) {
            return `${Math.floor(time/60).toString().padStart(2, '0')}:${(time%60).toString().padStart(2, '0')}`;
        } else {
            return '';
        }
    }

    // noinspection JSMethodCanBeStatic
    public stringToTime(string: string): number {
        // time in seconds eg: 59
        let regex = /^[0-9]*$/;
        let time = regex.exec(string);
        if (time) {
            return parseInt(time[0], 10);

        // time with minutes eg: 1:59
        } else {
            regex = /^([0-9]+):([0-9]+)$/;
            time = regex.exec(string);
            if (time) {
                const minutes = parseInt(time[1], 10);
                const seconds = parseInt(time[2], 10);
                return minutes * 60 + seconds;
            }
        }
        throw Error('Insert time with the format mm:ss (eg: 1:20) or in seconds (eg: 80).');
    }

    public newVideo() {
        this.video = new Video();
        this.showModal = true;
        this.start_time = this.video.start_time;
        this.end_time = this.video.end_time;
        this.display_condition = this.video.display_condition;
        this.tags = this.video.tags;
    }

    public edit(video: Video) {
        this.video = video;
        this.showModal = true;
        this.start_time = this.video.start_time;
        this.end_time = this.video.end_time;
        this.display_condition = this.video.display_condition;
        this.tags = this.video.tags;
    }

    // noinspection JSMethodCanBeStatic
    public getLink(video: Video): string {
        const regex = /(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|[a-zA-Z0-9_\-]+\?v=)([^#&?\n<>'"]*)/;
        const linkCode = regex.exec(video.url);
        if (linkCode && video.start_time) {
            return `https://www.youtube.com/embed/${linkCode[2]}?rel=0&amp;start=${video.start_time}`;
        } else if (linkCode) {
            return `https://www.youtube.com/embed/${linkCode[2]}?rel=0&amp`;
        } else {
            return '';
        }
    }

    public saveClicked() {
        if (!this.video) {
            return;
        }

        this.busy = true;

        try {

            if (this.start_time) {
                this.video.start_time = this.start_time;
            }

            if (this.end_time) {
                this.video.end_time = this.end_time;
            }

            if (this.display_condition) {
                this.video.display_condition = this.display_condition;
            }

            if (this.tags) {
                this.video.tags = this.tags;
            }

            this.checkMandatoryFields();
            if (this.video.state === 'created') {
                this.videos.push(this.video);
            }
            this.video.state = 'updated';
            this.busy = false;
            this.showModal = false;
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save video', e);
        }
    }
    
    public checkMandatoryFields() {
        // Check if link is filled
        if(!this.video.url) {
            throw Error('Please insert a link for your video.');
        }
        if (this.video.interface_elements) {
            try {
                this.video.interface_elements = JSON.stringify(JSON.parse(this.video.interface_elements));
            } catch (e) {
                throw Error('Json string is of an invalid format.');
            }
        }
    }
    
    public deleteClicked() {
        this.video.state = 'deleted';
        this.showModal = false;
    }
}
